/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description useGeoLocation hook
 */

import { selectIsMounted } from '@zcode-ui/web-zumper-global-state'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ON_BROWSER } from '../../../shared/env'
import GeoLocationContext from './GeoLocationContext'

const useGeoLocation = () => {
  const getGeoLocation = useContext(GeoLocationContext)
  const appMounted = useSelector(selectIsMounted)
  const isSafeForClientOnly = appMounted && ON_BROWSER
  return [getGeoLocation, isSafeForClientOnly] as const
}

export default useGeoLocation
